import { PORTAL_PATH } from '../../../routes/paths';
import { CheckIfUserHasPortalPrivilege, CheckIfUserHasApiPrivilege } from '../../../common/client-status/interfaces';

import { SubPageItem } from './interfaces';
import { dictionary as subpagesDictionary } from './dictionary';

export const getAvailableSubpages = (
  checkIfUserHasPortalPrivilege: CheckIfUserHasPortalPrivilege,
  checkIfUserHasApiPrivilege: CheckIfUserHasApiPrivilege,
  currentPage?: PORTAL_PATH,
  localDictionary?: SubPageItem[]
) => {
  const subpageDictionary = localDictionary || (currentPage && subpagesDictionary[currentPage]);

  if (subpageDictionary) {
    return subpageDictionary.reduce((filteredSubPages, subpage) => {
      const { portalPrivilege, apiPrivilege } = subpage;

      if (apiPrivilege !== null) {
        if (checkIfUserHasApiPrivilege(apiPrivilege)) {
          filteredSubPages.push(subpage);
        } else {
          return filteredSubPages;
        }
      } else if (checkIfUserHasPortalPrivilege(portalPrivilege)) {
        filteredSubPages.push(subpage);
      }

      return filteredSubPages;
    }, [] as SubPageItem[]);
  }

  return [];
};
